const removeJobIDfromLocalstorageCommon = (jobID) => {
	let jobsIDfromLocalstorage = JSON.parse(localStorage.getItem(`careerSavedJobsID_${lang}`));
		jobsIDfromLocalstorage = jobsIDfromLocalstorage.filter(id => id !== jobID);

	localStorage.setItem(`careerSavedJobsID_${lang}`, JSON.stringify(jobsIDfromLocalstorage));
};

export default  removeJobIDfromLocalstorageCommon;